// Digismoothie Agency Customisations

// Wrap certain product info with DIV
if ($( ".product-block__info-group" )) $( ".product-block__info-group" ).wrapAll( "<div class='product-block__wrapper info-group' />");
if ($( ".product-block__price-group" )) $( ".product-block__price-group" ).wrapAll( "<div class='product-block__wrapper price-group' />");

// Remove extra parent node from table
const tableWrapper = document.querySelector('.table-wrapper');
if (tableWrapper !== null) {
  const originalTable = tableWrapper.querySelectorAll('table');
  if (originalTable.length > 1) {
    const newTable = originalTable[originalTable.length - 1];
    tableWrapper.innerHTML = newTable.outerHTML;
  }
}


// Other Customisations

// Subscription product in-stock-hidden sku-hidden
document.addEventListener("DOMContentLoaded", function() {
    if (window.location.href.includes('dealers-jetsurf-official-e-shop-management') || window.location.href.includes('dealer-social-media-management')) {
        var productBlockWrapper = document.querySelector('.product-block__wrapper.info-group .product-block.product-block--sales-point.product-block__info-group');
        var productSKU = document.querySelector('.product-single__sku');

        if (productBlockWrapper) {
            productBlockWrapper.style.display = 'none';
        }
        if (productSKU) {
            productSKU.style.display = 'none';
        }
    }
});
